/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';


export interface InitializeCheckoutV2$Params {

/**
 * CAS authentication token in Bearer format. Takes priority over the Authorization header if both are present.
 */
  oauth_token?: any;
  cartId?: string;
  orderId?: string;
  orderChangeId?: string;
  locale?: string;
  hash?: string;
  'True-Client-IP'?: string;
  'X-Forwarded-For'?: string;
  device?: string;
  service?: string;
  successUrl: string;
  failureUrl: string;
  testVariant?: string;
}

export function initializeCheckoutV2(http: HttpClient, rootUrl: string, params: InitializeCheckoutV2$Params, context?: HttpContext): Observable<DapiHttpResponse<void>> {
  const rb = new DapiRequestBuilder(rootUrl, initializeCheckoutV2.PATH, 'post');

  if (params) {
    rb.header('oauth_token', params.oauth_token, {});
    rb.query('cartId', params.cartId, {});
    rb.query('orderId', params.orderId, {});
    rb.query('orderChangeId', params.orderChangeId, {});
    rb.query('locale', params.locale, {});
    rb.query('hash', params.hash, {});
    rb.header('True-Client-IP', params['True-Client-IP'], {});
    rb.header('X-Forwarded-For', params['X-Forwarded-For'], {});
    rb.query('device', params.device, {});
    rb.query('service', params.service, {});
    rb.query('successUrl', params.successUrl, {});
    rb.query('failureUrl', params.failureUrl, {});
    rb.query('testVariant', params.testVariant, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as DapiHttpResponse<void>;
    }),
    catchErrorAsJson()
  );
}

initializeCheckoutV2.PATH = '/api/v2/checkout/initialize';
